import { useCallback, useEffect, useMemo } from 'react'
import { ConfirmModal } from 'components/dialog/ModalTemplate'
import Join from 'components/Join'
import { Modal } from '../../components/dialog/Modals'
import { useDispatch, useSelector } from 'react-redux'
import { hideReviewReason } from './reviewReasonSlice'
import Loading from '../../components/loading/Loading'

const ReviewReasonModal = () => {
  const dispatch = useDispatch()
  const { visible, isLoading, showSubtitle, reviewTargetType, reasons } =
    useSelector(state => state.reviewReason)
  const subTitle = useMemo(() => reviewTargetType.title, [reviewTargetType])
  const handleClose = useCallback(
    () => dispatch(hideReviewReason()),
    [dispatch]
  )

  useEffect(
    () => () => {
      dispatch(hideReviewReason())
    },
    [dispatch]
  )

  return (
    <Modal on={visible} className="reason_layer">
      <ConfirmModal
        title="사유확인"
        handleClose={handleClose}
        showCancelBtn={false}>
        {showSubtitle && <p className="subtit_layer">{subTitle}</p>}
        {isLoading ? (
          <div className="list_append">
            <Loading />
          </div>
        ) : (
          <ul className="list_append">
            {reasons?.map((reasonDetail, index) => (
              <li key={index}>
                상세보류사유
                <br />
                <Join divider={<br />}>{reasonDetail.split('\n')}</Join>
              </li>
            ))}
          </ul>
        )}
      </ConfirmModal>
    </Modal>
  )
}

export default ReviewReasonModal
